// Resto del sitio: builder en runtime, home, horario, cookies, páginas de error — Español.
//
// Existe en es, pt y en (mismas claves; `npm run test:i18n-en-paridad` lo verifica).
// Estos textos estaban fijos en español en el código: cada valor de acá tiene que
// ser IDÉNTICO al literal que reemplaza.
export const siteEs = {
  embeds: {
    howItWorks: '¿Cómo funciona?',
    benefitsTitle: 'Beneficios',
    contactInfo: 'Información de contacto',
    phone: 'Teléfono',
    email: 'Email',
    emails: 'Emails',
    openingHours: 'Horario de atención',
    teamTitle: 'Nuestro Equipo',
    agendar: {
      step1Title: 'Elige la sucursal',
      step1Desc: 'Selecciona dónde quieres visitarnos.',
      step2Title: 'Escoge día y hora',
      step2Desc: 'Mira la disponibilidad y reserva tu horario.',
      step3Title: 'Déjanos tus datos',
      step3Desc: 'Completa tu nombre y contacto.',
      step4Title: 'Te esperamos',
      step4Desc: 'Recibirás la confirmación de tu visita.',
    },
  },
  whatsapp: {
    contactAria: 'Contactar por WhatsApp',
  },
  // /about sin página del builder (TraditionalAbout). `knowMore` lleva el
  // espacio final: el nombre va en un nodo aparte, como siempre.
  about: {
    title: 'Nosotros',
    knowMore: 'Conoce mas sobre ',
    fallbackName: 'nosotros',
    comingSoon: 'Esta pagina estara disponible proximamente.',
  },
  error: {
    title: 'Algo salió mal',
    description: 'Ocurrió un error inesperado al cargar esta sección. Podés intentar de nuevo.',
    retry: 'Intentar de nuevo',
  },
  cookies: {
    aria: 'Consentimiento de cookies',
    title: 'Usamos cookies para mejorar tu experiencia',
    description: 'Utilizamos cookies de terceros (Meta, Google) para medir el tráfico y mostrarte contenido más relevante. Puedes aceptar o rechazar su uso en cualquier momento.',
    reject: 'Rechazar',
    accept: 'Aceptar',
  },
  nav: {
    closeMenu: 'Close menu',
    openMenu: 'Open menu',
    menuClose: 'Cerrar menú',
    menuOpen: 'Abrir menú',
    toggleTheme: 'Cambiar tema',
  },
  footer: {
    rights: 'Todos los derechos reservados.',
  },
  vehicles: {
    searchPlaceholder: 'Buscar por marca, modelo o año...',
    searchBrand: 'Buscar marca...',
    searchYear: 'Buscar año...',
    searchType: 'Buscar tipo...',
    noOptions: 'No hay opciones disponibles',
    filters: 'Filtros',
    reset: 'Resetear',
    back: 'Volver',
    clear: 'Limpiar',
    hideFilters: 'Ocultar filtros',
    showFilters: 'Mostrar filtros',
    priceRange: 'Rango de Precio',
    brand: 'Marca',
    dealership: 'Sucursal',
    year: 'Año',
    vehicleType: 'Tipo de Vehículo',
    fuel: 'Combustible',
    condition: 'Condición',
    color: 'Color',
    carType: 'Tipo de auto',
    transmission: 'Transmisión',
    priceFromTo: 'Precio Desde - Hasta',
    yearFromTo: 'Año Desde - Hasta',
    allMasc: 'Todos',
    allFem: 'Todas',
    exploreStock: 'Explora nuestro stock',
    priceOnRequest: 'Consultar',
    viewDetails: 'Ver detalles',
    available: 'Disponible',
    kmsUnit: 'kms',
    vehicleAlt: 'Vehículo',
    noneAvailableTitle: 'No hay vehículos disponibles',
    noneAvailableText: 'En este momento no hay vehículos para mostrar',
    noResultsTitle: 'No se encontraron vehículos',
    noResultsText: 'Intenta ajustar los filtros',
    noResultsTextSearch: 'Intenta ajustar los filtros o buscar otra cosa',
    removeAllFilters: 'Quitar todos los filtros',
    found: 'vehículos encontrados',
    noMatches: 'No hay vehículos que coincidan con los filtros seleccionados.',
    sortBy: 'Ordenar por',
    sortDateDesc: 'Recientes primero',
    sortDateAsc: 'Antiguos primero',
    sortPriceAsc: 'Precio: Menor a Mayor',
    sortPriceDesc: 'Precio: Mayor a Menor',
    sortYearDesc: 'Año: Más Reciente',
    sortYearAsc: 'Año: Más Antiguo',
    sortMileageAsc: 'Kilometraje: Menor a Mayor',
    scrollLeft: 'Scroll left',
    scrollRight: 'Scroll right',
    types: {
      all: 'Todos',
      suv: 'SUVs',
      sedan: 'Sedanes',
      hatchback: 'Hatchbacks',
      pickup: 'Pickups',
      camioneta: 'Camionetas',
      van: 'Vans',
      coupe: 'Coupés',
      wagon: 'Wagons',
      trabajo: 'Vehículos de trabajo',
    },
  },
  hero: {
    badge: 'Tu próximo auto te espera',
    makeModel: 'Marca y Modelo',
    makeModelPlaceholder: 'Ej: Toyota Corolla',
    from: 'Desde',
    to: 'Hasta',
    price: 'Precio',
    min: 'Mínimo',
    max: 'Máximo',
    model: 'Modelo',
    search: 'Buscar',
    featuredCarAlt: 'Auto destacado',
    allBrands: 'Todas las marcas',
    allModels: 'Todos los modelos',
    allYears: 'Todos los años',
    anyPrice: 'Cualquier precio',
    trustedDealer: 'Tu automotora de confianza',
    warrantyIncluded: 'Garantía incluida',
    flexibleFinancing: 'Financiamiento flexible',
    homeDelivery: 'Envío a domicilio',
  },
  sections: {
    learnMore: 'Conoce más',
    meetUs: 'Conócenos',
    videoInvalid: 'Por favor, ingresa una URL de video válida (YouTube o Vimeo).',
    videoExample: 'Ej: https://www.youtube.com/watch?v=VIDEO_ID',
  },
  carousel: {
    empty: 'Agregá imágenes al carrusel desde el panel de la derecha',
    image: 'Imagen',
    previous: 'Anterior',
    next: 'Siguiente',
    goTo: 'Ir a la imagen',
  },
  stats: {
    eyebrow: 'En cifras',
    title: 'Nuestros números',
  },
  whyUs: {
    item1Title: 'Garantía',
    item1Description: 'Todos nuestros vehículos cuentan con garantía',
    item2Title: 'Financiamiento',
    item2Description: 'Opciones de financiamiento flexibles',
    item3Title: 'Calidad',
    item3Description: 'Vehículos seleccionados y certificados',
  },
  skeleton: {
    all: 'Todos',
    sedan: 'Sedán',
  },
  // Textos DE FÁBRICA de las secciones del builder (los que el admin guarda al
  // soltar una sección, y los `craft.props`), IDÉNTICOS al literal. No se leen
  // con t(): los usa builder2/utils/defaultsPt para mostrarlos en portugués en
  // los sitios de Brasil cuando la automotora no los editó. La clave solo
  // empareja es ↔ pt (misma clave = misma frase).
  // La lista grande vive en builder2/i18n/defaultsPt.{a,b}.ts (copia de los
  // mapas del admin); acá quedan solo los textos de fábrica que esos mapas no
  // traen. 'Nuevo' NO va: es un centinela (`newBadgeText === 'Nuevo'` rota las
  // etiquetas automáticas de la tarjeta).
  builderDefaults: {
    d002: 'Título de sección',
    d003: 'Un título que acompaña la imagen',
    d004: 'Contá acá lo que quieras destacar. Este bloque combina una imagen con texto y un botón opcional.',
    d005: 'Título de la tarjeta',
    d006: 'Una descripción breve de lo que ofrece esta tarjeta.',
    d019: 'Un beneficio destacado',
    d020: 'Explicá en una línea por qué le conviene al cliente.',
    d106: 'Comprador de Toyota Corolla',
    d108: 'Compradora de Honda CR-V',
    d110: 'Comprador de Nissan Sentra',
    d199: 'Si no quedás conforme, te devolvemos tu plata',
  },
};
